import * as ambassadorWixSearchPlatformizedV1SiteDocument from './search-platformized-v1-site-document-wix-site-search.http.js';
import * as ambassadorWixSearchPlatformizedV1SiteDocumentTypes from './search-platformized-v1-site-document-wix-site-search.types.js';
import * as ambassadorWixSearchPlatformizedV1SiteDocumentUniversalTypes from './search-platformized-v1-site-document-wix-site-search.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function search(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchPlatformizedV1SiteDocumentUniversalTypes.SearchRequest,
  ambassadorWixSearchPlatformizedV1SiteDocumentTypes.SearchRequest,
  ambassadorWixSearchPlatformizedV1SiteDocumentUniversalTypes.SearchResponse,
  ambassadorWixSearchPlatformizedV1SiteDocumentTypes.SearchResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSearchPlatformizedV1SiteDocument.search(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function autocomplete(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchPlatformizedV1SiteDocumentUniversalTypes.AutocompleteRequest,
  ambassadorWixSearchPlatformizedV1SiteDocumentTypes.AutocompleteRequest,
  ambassadorWixSearchPlatformizedV1SiteDocumentUniversalTypes.AutocompleteResponse,
  ambassadorWixSearchPlatformizedV1SiteDocumentTypes.AutocompleteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSearchPlatformizedV1SiteDocument.autocomplete(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/autocomplete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function suggest(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSearchPlatformizedV1SiteDocumentUniversalTypes.SuggestRequest,
  ambassadorWixSearchPlatformizedV1SiteDocumentTypes.SuggestRequest,
  ambassadorWixSearchPlatformizedV1SiteDocumentUniversalTypes.SuggestResponse,
  ambassadorWixSearchPlatformizedV1SiteDocumentTypes.SuggestResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSearchPlatformizedV1SiteDocument.suggest(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/suggest',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SiteDocument as SiteDocumentOriginal,
  SearchRequest as SearchRequestOriginal,
  Search as SearchOriginal,
  SearchPagingMethodOneOf as SearchPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Paging as PagingOriginal,
  DocumentType as DocumentTypeOriginal,
  DocumentTypeWithLiterals as DocumentTypeWithLiteralsOriginal,
  SearchResponse as SearchResponseOriginal,
  SearchResponsePagingOneOf as SearchResponsePagingOneOfOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  ValueResults as ValueResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  ValueResult as ValueResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  PagingMetadata as PagingMetadataOriginal,
  AutocompleteRequest as AutocompleteRequestOriginal,
  AutocompleteResponse as AutocompleteResponseOriginal,
  AutocompleteResponseValue as AutocompleteResponseValueOriginal,
  SuggestRequest as SuggestRequestOriginal,
  Suggest as SuggestOriginal,
  SuggestPagingMethodOneOf as SuggestPagingMethodOneOfOriginal,
  SuggestDetails as SuggestDetailsOriginal,
  SuggestResponse as SuggestResponseOriginal,
} from './search-platformized-v1-site-document-wix-site-search.types.js';
